import { Article } from "./categories";

export const articles: Article[] = [
  {
    id: "article-1",
    title: "百万粉丝网红「甜心小鹿」直播翻车现场曝光，真实颜值与精修照判若两人",
    excerpt: "拥有120万粉丝的美妆博主「甜心小鹿」在一次户外直播中因设备故障意外暴露真实面容，与日常发布的精修照片差距巨大，引发全网热议。粉丝纷纷表示「塌房了」。",
    content: `<p>近日，拥有超过120万粉丝的美妆博主「甜心小鹿」在一次户外直播中遭遇了职业生涯最严重的翻车事件。据悉，当天她正在进行一场户外美妆教程直播，由于直播设备突然出现故障，美颜滤镜在直播中途关闭了将近三分钟。</p>
<p>在这三分钟内，观众看到了她未经任何修饰的真实面容，与她在社交平台上发布的精修照片存在明显差距。直播间的弹幕瞬间炸开了锅，「这是同一个人吗？」「我的天塌房了」等评论刷屏。</p>
<p>事后，「甜心小鹿」紧急下播，并在微博发文道歉，称自己「一直有容貌焦虑，所以才会过度依赖美颜和修图」，希望粉丝能够理解。</p>
<p>然而这一解释并未平息争议，反而引发了更多网友的讨论。有人表示理解，认为现在的主播都在用美颜滤镜，这已经是行业潜规则；但也有大量粉丝表示受到了欺骗，尤其是那些因为她的「颜值」而购买推荐产品的消费者。</p>
<p>截至发稿前，该事件仍在持续发酵中。据业内人士透露，「甜心小鹿」的多家品牌合作已经暂停，预计损失将超过200万元。</p>`,
    categoryId: "wanghong-tafang",
    tags: ["塌房", "翻车", "美颜滤镜", "人设崩塌"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20dramatic%20behind%20the%20scenes%20moment%20of%20a%20beauty%20live%20streamer%20with%20a%20shocked%20expression%20on%20her%20face%20looking%20at%20a%20phone%20screen%20showing%20two%20contrasting%20portraits%2C%20one%20heavily%20filtered%20one%20natural%2C%20warm%20studio%20lighting%20with%20ring%20light%20in%20background%2C%20editorial%20photography%20style%20with%20soft%20shadows%2C%20dramatic%20contrast%2C%20clean%20simple%20composition%20with%20neutral%20beige%20background&width=800&height=500&seq=article-cover-01&orientation=landscape",
    author: "黑料小编",
    publishDate: "2026-07-06",
    viewCount: 1285000,
    commentCount: 36800,
    isHot: true,
    isFeatured: true,
    readTime: 8,
  },
  {
    id: "article-2",
    title: "知名带货主播「大鹏哥」被曝售卖假货，品牌方连夜发声明撇清关系",
    excerpt: "拥有500万粉丝的带货主播「大鹏哥」被消费者联合举报售卖假冒名牌手表，涉及金额超过500万元。品牌方连夜发布声明称从未与其合作。",
    content: `<p>7月5日晚间，一条关于知名带货主播「大鹏哥」售卖假冒名牌手表的爆料在社交平台迅速传播。据多位消费者反映，他们通过「大鹏哥」直播间购买的某国际名牌手表，经专业鉴定均为仿冒品。</p>
<p>据不完全统计，此次涉及的消费者超过200人，总金额超过500万元。部分消费者表示，当初之所以购买是因为「大鹏哥」在直播中信誓旦旦地保证「假一赔十」，并且展示了所谓的「品牌授权书」。</p>
<p>然而，该品牌官方于7月6日凌晨紧急发布声明，明确表示从未与「大鹏哥」及其所属公司有过任何形式的合作，所谓「品牌授权书」系伪造文件。品牌方同时表示已委托律师收集证据，将追究相关责任方的法律责任。</p>
<p>「大鹏哥」方面截至目前尚未作出正式回应，但其直播间已在事件曝光后紧急关闭。有网友发现，其多个社交媒体账号的评论区已经被愤怒的消费者攻陷。</p>
<p>据业内人士分析，此次事件可能成为今年以来直播带货领域最大的翻车事件，或将推动相关部门进一步加强对直播带货行业的监管。</p>`,
    categoryId: "wanghong-tafang",
    tags: ["假货", "塌房", "直播带货", "实锤"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20luxurious%20watch%20placed%20dramatically%20on%20a%20dark%20wooden%20table%20under%20spotlight%20with%20a%20large%20red%20X%20mark%20shadow%20cast%20over%20it%2C%20a%20smartphone%20beside%20it%20showing%20a%20live%20streaming%20interface%20with%20warning%20icons%2C%20dark%20moody%20lighting%2C%20editorial%20product%20photography%20style%2C%20clean%20minimal%20composition%20with%20deep%20shadows&width=800&height=500&seq=article-cover-02&orientation=landscape",
    author: "每日爆料组",
    publishDate: "2026-07-05",
    viewCount: 2150000,
    commentCount: 58200,
    isHot: true,
    isFeatured: true,
    readTime: 10,
  },
  {
    id: "article-3",
    title: "某顶流男星深夜密会神秘女子，酒店同进同出被拍",
    excerpt: "近日有媒体拍到某当红男星深夜与一名神秘女子在某五星级酒店同进同出，两人举止亲密。该男星此前一直以「单身」人设示人。",
    content: `<p>近日，有知名娱乐媒体拍到某当红男星深夜与一名神秘女子在某五星级酒店同进同出的画面。据目击者描述，两人举止亲密，该女子多次挽着男星的手臂，男星也并未拒绝。</p>
<p>值得注意的是，该男星此前在多个公开场合以及综艺节目中均以「单身」人设示人，并多次表示自己「专注事业，暂时不考虑感情问题」。此次被拍到与异性亲密同行，无疑是对其人设的一次重击。</p>
<p>截至目前，该男星的经纪公司尚未对此事作出回应。粉丝群体内部也出现了分化：一部分粉丝表示「相信哥哥」，认为这可能是正常的朋友交往；另一部分粉丝则表示失望，认为自己的信任被辜负。</p>
<p>有业内人士分析称，如果此事确为恋情曝光，该男星的商业价值可能会受到较大影响，尤其是在他代言的多个品牌中，有相当一部分是面向女性消费者的产品。</p>`,
    categoryId: "mingxing-bagua",
    tags: ["恋情", "塌房", "人设崩塌", "单身人设"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20silhouette%20of%20a%20couple%20walking%20hand%20in%20hand%20in%20front%20of%20a%20luxury%20hotel%20entrance%20at%20night%2C%20blurred%20motion%20effect%2C%20dramatic%20backlighting%20from%20hotel%20lobby%2C%20paparazzi%20style%20photography%20aesthetic%2C%20cinematic%20mood%20with%20warm%20golden%20and%20dark%20tones%2C%20clean%20composition&width=800&height=500&seq=article-cover-03&orientation=landscape",
    author: "深夜吃瓜组",
    publishDate: "2026-07-04",
    viewCount: 3890000,
    commentCount: 125000,
    isHot: true,
    isFeatured: false,
    readTime: 6,
  },
  {
    id: "article-4",
    title: "抖音千万粉丝网红「阿强」被前女友曝出轨实锤，聊天记录全曝光",
    excerpt: "抖音头部网红「阿强」前女友在微博发布长文，曝光两人恋爱期间阿强多次出轨的证据，包括大量聊天记录截图，引发全网震动。",
    content: `<p>7月3日晚，抖音千万粉丝网红「阿强」的前女友在个人微博发布了一篇长达5000字的长文，详细揭露了两人恋爱期间阿强多次出轨的细节，并附上了大量聊天记录截图作为证据。</p>
<p>根据长文内容，两人于2025年初开始交往，恋爱期间阿强先后与至少五位女性保持暧昧关系。前女友表示，自己一开始选择了原谅，但阿强屡教不改，最终在2026年3月分手。</p>
<p>此次选择公开爆料的原因，据前女友称是因为「阿强在分手后仍然不断骚扰她，并且还威胁她不要把这些事情说出去」。她表示自己「忍无可忍，决定把真相公之于众」。</p>
<p>聊天记录截图显示的内容令人瞠目结舌，其中包含大量露骨的对话。这些截图在社交媒体上迅速传播，「阿强出轨」话题在短短两小时内登上微博热搜第一。</p>
<p>截至目前，「阿强」方面尚未作出回应，但其抖音账号的评论区已全面沦陷，大量粉丝留言表示「取关」「失望透顶」。</p>`,
    categoryId: "chigua-baoliao",
    tags: ["出轨", "实锤", "聊天记录", "塌房"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20chat%20conversation%20interface%20with%20dramatic%20red%20warning%20highlights%20on%20certain%20messages%2C%20the%20phone%20lying%20on%20a%20dark%20surface%20with%20dramatic%20side%20lighting%2C%20moody%20atmosphere%2C%20cinematic%20photography%20style%20with%20deep%20shadows%2C%20clean%20minimal%20composition&width=800&height=500&seq=article-cover-04&orientation=landscape",
    author: "吃瓜一线",
    publishDate: "2026-07-03",
    viewCount: 5200000,
    commentCount: 189000,
    isHot: true,
    isFeatured: false,
    readTime: 12,
  },
  {
    id: "article-5",
    title: "B站UP主抄袭事件持续发酵，多位原创作者联合维权",
    excerpt: "B站知名UP主「创意工坊」被指长期抄袭海外创作者内容，至今已有超过50位原创作者联合发声维权，B站官方已介入调查。",
    content: `<p>近日，B站知名UP主「创意工坊」（粉丝数：280万）被指长期系统性抄袭海外YouTube创作者的内容，引发了国内外创作者群体的广泛关注。</p>
<p>事情的起因是一位海外YouTuber在自己的社交媒体上指出，「创意工坊」最新发布的一期视频与自己三个月前发布的视频在选题、结构、甚至分镜上都高度相似，几乎可以说是「逐帧复刻」。</p>
<p>随后，越来越多的海外创作者站出来指认「创意工坊」抄袭了自己的内容。据统计，截至目前已有超过50位创作者联合发声维权，涉及的抄袭视频超过100期。</p>
<p>B站官方于7月2日发布公告，表示已经注意到相关争议，并已启动调查程序。根据B站的社区规则，如果抄袭行为被证实，「创意工坊」可能面临频道封禁的处罚。</p>
<p>「创意工坊」本人至今未作出公开回应，但其最新几期视频的评论区已经被网友的质疑声淹没。不少粉丝表示，「取关不是因为不喜欢你的内容，而是因为内容本来就不属于你」。</p>`,
    categoryId: "chigua-baoliao",
    tags: ["抄袭", "维权", "B站", "实锤"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20split%20screen%20composition%20showing%20two%20video%20editing%20timelines%20side%20by%20side%20with%20highlighted%20identical%20sections%20in%20red%2C%20computer%20monitor%20displaying%20this%20comparison%20on%20a%20modern%20desk%2C%20dramatic%20contrast%20lighting%2C%20editorial%20style%2C%20clean%20dark%20background&width=800&height=500&seq=article-cover-05&orientation=landscape",
    author: "版权卫士",
    publishDate: "2026-07-02",
    viewCount: 1860000,
    commentCount: 42800,
    isHot: true,
    isFeatured: false,
    readTime: 9,
  },
  {
    id: "article-6",
    title: "快手头部主播带货翻车：宣称「纯金」实际为镀金，消费者集体投诉",
    excerpt: "快手800万粉丝主播「金姐」直播间售卖的「999纯金首饰」被检测为镀金产品，大量消费者向市场监管局投诉，涉事金额超千万。",
    content: `<p>快手头部主播「金姐」再次陷入带货翻车风波。近日，有消费者对其直播间售卖的「999纯金首饰」进行专业检测，结果显示这些首饰并非纯金，而是镀金产品，金含量远低于宣传标准。</p>
<p>这一检测结果迅速在消费者群体中传播开来，大量购买了该产品的消费者纷纷将首饰送检，结果均显示为镀金。据不完全统计，仅这一款产品涉及的销售额就超过1000万元。</p>
<p>面对消费者的质疑，「金姐」在直播中回应称自己也是受害者，被供应商欺骗。然而，有业内人士指出，作为头部主播，选品团队有责任对产品进行严格审核，不能简单地将责任推给供应商。</p>
<p>目前，已有超过500名消费者联合向市场监管局投诉，部分消费者已委托律师准备提起集体诉讼。法律专家表示，如果最终认定为主播存在虚假宣传，除了退一赔三的消费者赔偿外，还可能面临行政处罚。</p>`,
    categoryId: "zhibo-fanju",
    tags: ["翻车", "假货", "直播带货", "维权"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20gold%20colored%20necklace%20being%20inspected%20under%20a%20magnifying%20glass%20on%20a%20jewelry%20testing%20workbench%2C%20a%20certificate%20report%20beside%20it%20with%20a%20red%20FAIL%20stamp%2C%20professional%20jewelry%20appraisal%20scene%2C%20clean%20white%20background%20with%20soft%20studio%20lighting%2C%20editorial%20photography&width=800&height=500&seq=article-cover-06&orientation=landscape",
    author: "消费维权组",
    publishDate: "2026-07-01",
    viewCount: 2450000,
    commentCount: 63500,
    isHot: false,
    isFeatured: false,
    readTime: 7,
  },
  {
    id: "article-7",
    title: "小红书知名穿搭博主被扒全是「拼多多同款」，翻三倍价格卖给粉丝",
    excerpt: "小红书60万粉丝穿搭博主「时尚酵母」被粉丝扒出其推荐的所有服饰均可在拼多多以三分之一价格购买同款，引发信任危机。",
    content: `<p>小红书知名穿搭博主「时尚酵母」近日遭遇了从业以来最大的信任危机。有细心粉丝发现，该博主推荐并售卖的「原创设计」服饰，几乎全部可以在拼多多上找到一模一样的产品，价格仅为博主售价的三分之一。</p>
<p>更令人震惊的是，部分产品甚至连商品详情页的模特图都完全相同，只是换了品牌标签。这一发现迅速在粉丝群体中传播开来，大量被「种草」并购买过的粉丝表示愤怒。</p>
<p>「时尚酵母」随后发布了一则回应视频，声称自己售卖的是「升级版」，在面料和做工上与拼多多产品不同。然而这一解释并未获得粉丝认可，有购买了产品的粉丝将两件商品进行对比，发现完全一致。</p>
<p>事件发酵后，「时尚酵母」的大量合作品牌纷纷解约，其小红书店铺也被平台暂时关闭。据业内人士估算，此次事件造成的直接经济损失可能超过300万元。</p>`,
    categoryId: "shejiao-reshi",
    tags: ["小红书", "翻车", "价格欺诈", "人设崩塌"],
    coverImage: "https://readdy.ai/api/search-image?query=Two%20identical%20fashion%20outfits%20displayed%20side%20by%20side%20on%20hangers%20one%20with%20a%20luxury%20brand%20tag%20and%20the%20other%20with%20a%20budget%20tag%2C%20with%20dramatically%20different%20price%20labels%20visible%2C%20clean%20studio%20setting%20with%20soft%20neutral%20background%2C%20editorial%20fashion%20photography%20style&width=800&height=500&seq=article-cover-07&orientation=landscape",
    author: "时尚打假组",
    publishDate: "2026-06-30",
    viewCount: 1650000,
    commentCount: 39800,
    isHot: false,
    isFeatured: false,
    readTime: 6,
  },
  {
    id: "article-8",
    title: "全网热议！某综艺节目选手被爆学历造假，人设瞬间崩塌",
    excerpt: "正在热播的某选秀综艺节目中，一名人气选手被网友扒出学历造假。该选手自称「985高校研究生」，实际仅为成人教育专科。",
    content: `<p>正在某视频平台热播的选秀综艺节目中，一位人气选手因学历造假被推上舆论的风口浪尖。该选手在节目中多次表示自己毕业于某知名985高校，并且正在攻读该校的研究生学位，这一「学霸」人设为其赢得了大量粉丝的喜爱。</p>
<p>然而，有网友在学信网上查询后发现，该选手的真实学历为成人教育专科，与其在节目中宣称的「985高校研究生」相去甚远。这一发现经知名娱乐博主转发后，迅速引发全网热议。</p>
<p>面对质疑，该选手的经纪公司发表声明称「选手在节目中表述有误，并非故意造假」，但这一蹩脚的解释不仅未能平息争议，反而引发了更多网友的嘲讽。</p>
<p>节目组方面目前尚未对此事作出回应。有知情人士透露，该选手可能面临退赛处理。同时，其代言的多个品牌也在紧急评估是否继续合作。</p>`,
    categoryId: "mingxing-bagua",
    tags: ["学历造假", "综艺", "人设崩塌", "塌房"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20dramatic%20contrast%20between%20a%20prestigious%20university%20diploma%20on%20the%20left%20side%20with%20a%20large%20red%20question%20mark%20overlaid%2C%20and%20a%20stage%20spotlight%20on%20the%20right%20side%2C%20split%20composition%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20editorial%20style%2C%20clean%20dark%20background&width=800&height=500&seq=article-cover-08&orientation=landscape",
    author: "学历打假办",
    publishDate: "2026-06-29",
    viewCount: 3120000,
    commentCount: 87600,
    isHot: false,
    isFeatured: false,
    readTime: 7,
  },
  {
    id: "article-9",
    title: "每日黑料大赛第七期投票开启：谁是你心中本月最大塌房咖？",
    excerpt: "每日黑料大赛第七期火热开启！本月候选名单包括甜心小鹿、大鹏哥、阿强等重磅塌房人物，谁能夺得「月度塌房之王」称号？由你投票决定！",
    content: `<p>每日黑料大赛第七期正式开启投票通道！经过编辑团队精心筛选，本期共有六位候选人入围「月度塌房之王」的角逐。他们分别是：因美颜滤镜翻车的「甜心小鹿」、涉嫌售卖假冒手表的「大鹏哥」、被前女友实锤出轨的「阿强」、抄袭风波的「创意工坊」、假黄金事件的「金姐」以及学历造假的选秀选手。</p>
<p>投票规则：每位注册用户每天可投3票，可以投给不同的候选人，也可以全部投给同一位候选人。投票截止时间为7月31日23:59。</p>
<p>上期大赛回顾：第六期「月度塌房之王」由带货翻车主播「豪哥」以128万票夺得，其因售卖劣质燕窝被市场监管局罚款500万元。</p>
<p>本期大赛奖品：获得「月度塌房之王」称号的候选人相关深度报道将在每日黑料首页置顶展示一周，同时我们将邀请资深娱评人撰写万字长文深度分析。</p>`,
    categoryId: "meiri-dasai",
    tags: ["每日黑料大赛", "投票", "塌房之王", "月度评选"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20dramatic%20golden%20trophy%20on%20a%20dark%20stage%20with%20spotlights%2C%20surrounded%20by%20six%20silhouetted%20portrait%20frames%20in%20a%20circular%20arrangement%2C%20red%20carpet%20leading%20to%20the%20center%2C%20grand%20award%20ceremony%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20dramatic%20background%2C%20premium%20editorial%20style&width=800&height=500&seq=article-cover-09&orientation=landscape",
    author: "每日黑料大赛组委会",
    publishDate: "2026-07-01",
    viewCount: 6800000,
    commentCount: 256000,
    isHot: true,
    isFeatured: true,
    readTime: 5,
  },
  {
    id: "article-10",
    title: "斗鱼知名游戏主播涉嫌「菠菜」推广，直播间已被永久封禁",
    excerpt: "斗鱼平台拥有150万粉丝的游戏主播「战神」被举报在直播中变相推广赌博网站，经平台核实后直播间已被永久封禁。",
    content: `<p>斗鱼平台知名游戏主播「战神」近日因涉嫌推广赌博网站被平台永久封禁。据知情人士透露，该主播在直播过程中多次以「福利活动」的名义引导观众点击外部链接，而这些链接最终导向的是境外赌博网站。</p>
<p>「战神」在斗鱼平台拥有超过150万粉丝，以《王者荣耀》高端局直播著称。近半年来，其直播内容中频繁出现所谓的「抽奖福利」，而参与方式则是要求观众点击指定的外部链接。</p>
<p>有观众举报后，斗鱼平台迅速介入调查，确认「战神」的行为违反了平台相关规定，随即对其直播间进行了永久封禁处理。这也是今年以来斗鱼平台处理的第三起类似事件。</p>
<p>业内人士指出，近年来部分主播为了高额佣金不惜铤而走险，变相推广赌博网站的现象屡禁不止，平台方需要加强审核力度，同时也呼吁观众提高警惕。</p>`,
    categoryId: "zhibo-fanju",
    tags: ["封禁", "赌博", "斗鱼", "翻车"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20gaming%20streaming%20setup%20with%20a%20large%20monitor%20displaying%20a%20red%20BANNED%20warning%20overlay%20on%20a%20game%20screen%2C%20dramatic%20red%20and%20dark%20lighting%2C%20gaming%20peripherals%20in%20the%20foreground%2C%20tense%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background&width=800&height=500&seq=article-cover-10&orientation=landscape",
    author: "平台观察员",
    publishDate: "2026-06-28",
    viewCount: 1350000,
    commentCount: 29800,
    isHot: false,
    isFeatured: false,
    readTime: 5,
  },
  {
    id: "article-11",
    title: "网红情侣「糖心夫妇」宣布分手，双方互爆黑料场面失控",
    excerpt: "曾被誉为「最甜网红情侣」的「糖心夫妇」突然宣布分手，随后双方在社交平台互相指责对方出轨、家暴，场面一度失控。",
    content: `<p>曾经被誉为「最甜网红情侣」的「糖心夫妇」于6月27日晚突然宣布分手，令人意外的是，两人随后在社交平台上展开了一场激烈的「互撕大战」，令吃瓜群众目不暇接。</p>
<p>先是女方发长文指控男方在恋爱期间多次出轨，并且有暴力倾向；随后男方不甘示弱，发布多条微博反击，称女方「颠倒黑白」，并反指女方与多名异性保持不正当关系。</p>
<p>两人的互撕持续了近六个小时，期间不断有「新料」被爆出，包括私密聊天记录、转账记录甚至打架的视频。这场面让吃瓜群众直呼「比电视剧还精彩」。</p>
<p>目前双方均已删除相关微博，但网络上的讨论仍在持续。有网友调侃道：「这就是传说中的最甜情侣吗？也太甜（吓）了吧。」</p>`,
    categoryId: "chigua-baoliao",
    tags: ["分手", "互撕", "出轨", "吃瓜"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20cracked%20heart%20shaped%20object%20split%20into%20two%20pieces%20on%20a%20dark%20surface%2C%20each%20piece%20pointing%20in%20opposite%20directions%2C%20dramatic%20side%20lighting%20creating%20harsh%20shadows%2C%20emotional%20and%20tense%20atmosphere%2C%20cinematic%20style%2C%20clean%20dark%20background&width=800&height=500&seq=article-cover-11&orientation=landscape",
    author: "感情观察员",
    publishDate: "2026-06-27",
    viewCount: 4560000,
    commentCount: 134000,
    isHot: true,
    isFeatured: false,
    readTime: 8,
  },
  {
    id: "article-12",
    title: "微博百万粉丝大V被曝为AI虚拟人，所有内容均为AI生成",
    excerpt: "微博一位拥有百万粉丝的「情感博主」被技术团队扒出所有内容均由AI生成，包括其「自拍」照片也是AI合成的虚拟人像。",
    content: `<p>近日，一个技术研究团队发布报告称，微博上一位拥有超过100万粉丝的知名情感博主实际上是一个AI虚拟人。该团队通过技术手段分析发现，该博主发布的所有文字内容均显示出AI生成的典型特征，而其「自拍」照片也被证实为AI合成的虚拟人像。</p>
<p>据报告显示，该博主账号于2025年3月创建，在不到一年半的时间内积累了百万粉丝。其发布的「情感语录」和「生活感悟」因为精准戳中当代年轻人的痛点而广受欢迎。</p>
<p>然而，当技术团队使用AI检测工具对其内容进行分析后，发现几乎百分之百的内容都是由AI生成的。更令人震惊的是，其所谓的「日常自拍」经过专业图像鉴定，被确认为AI生成的人像图片。</p>
<p>该账号目前尚未对此事作出回应，但已设置了「仅允许关注者评论」。微博平台方面表示正在核实相关情况。这一事件也引发了关于AI内容在社交平台上泛滥的广泛讨论。</p>`,
    categoryId: "shejiao-reshi",
    tags: ["AI", "虚拟人", "造假", "微博"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20humanoid%20robotic%20face%20half%20visible%20behind%20a%20cracked%20smartphone%20screen%2C%20the%20phone%20displaying%20a%20social%20media%20profile%20with%20glitchy%20artifacts%2C%20futuristic%20dystopian%20aesthetic%2C%20dark%20atmosphere%20with%20neon%20accents%2C%20cinematic%20photography%2C%20clean%20composition&width=800&height=500&seq=article-cover-12&orientation=landscape",
    author: "科技侦探",
    publishDate: "2026-06-26",
    viewCount: 1980000,
    commentCount: 52100,
    isHot: false,
    isFeatured: false,
    readTime: 7,
  },
];

export function getArticlesByCategory(categoryId: string): Article[] {
  return articles.filter((a) => a.categoryId === categoryId);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot).sort((a, b) => b.viewCount - a.viewCount);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured).sort((a, b) => b.viewCount - a.viewCount);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(article: Article, count: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.categoryId === article.categoryId)
    .slice(0, count);
}

export function getLatestArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
}

export function getMostViewedArticles(count: number = 5): Article[] {
  return [...articles].sort((a, b) => b.viewCount - a.viewCount).slice(0, count);
}